import { useCallback } from "react";

export const useSound = (soundPath) => {
  const play = useCallback(() => {
    try {
      const audio = new Audio(soundPath);
      audio.volume = 0.5; // صوت هادي مش عالي ومزعج
      audio.play().catch((err) => {
      });
    } catch (error) {
      console.error("Sound Error:", error);
    }
  }, [soundPath]);

  return play;
};